import { useState } from 'react';
import CareRequestForm from './components/CareRequestForm';
import SuccessModal from './components/SuccessModal';

export default function AdminCareRequestPage() {
  const [successReceiptNumber, setSuccessReceiptNumber] = useState<string | null>(null);

  const now = new Date();
  const dateStr = `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일`;

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f7faf9' }}>
      {/* Header */}
      <div className="w-full border-b border-gray-100 bg-white sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ backgroundColor: '#2E7D6B' }}>
              <i className="ri-file-list-3-line text-white text-sm"></i>
            </div>
            <div>
              <p className="text-xs text-gray-400">코리아케어러스 관리자</p>
              <h1 className="text-sm font-bold text-gray-900">가족간병 신청 접수</h1>
            </div>
          </div>
          <span className="text-xs text-gray-400">{dateStr}</span>
          <div className="flex items-center gap-2">
            <a
              href="/admin/match-list"
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold text-gray-600 bg-gray-50 border border-gray-200 cursor-pointer hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-hand-heart-line"></i>매칭내역
            </a>
            <a
              href="/admin/care-list"
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold text-gray-600 bg-gray-50 border border-gray-200 cursor-pointer hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-file-list-3-line"></i>신청목록
            </a>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 py-8">
        {/* Info banner */}
        <div className="flex items-start gap-3 p-4 rounded-xl mb-6 border" style={{ backgroundColor: '#f0f9f6', borderColor: '#c6e8df' }}>
          <i className="ri-information-line mt-0.5 flex-shrink-0" style={{ color: '#2E7D6B' }}></i>
          <div>
            <p className="text-sm font-semibold" style={{ color: '#2E7D6B' }}>관리자 전용 페이지</p>
            <p className="text-xs text-gray-500 mt-0.5">접수번호와 간병인 등록번호는 자동으로 생성됩니다. 접수 시간은 현재 시각으로 자동 기록됩니다.</p>
          </div>
        </div>

        <CareRequestForm onSuccess={(receiptNumber) => setSuccessReceiptNumber(receiptNumber)} />
      </div>

      {successReceiptNumber && (
        <SuccessModal
          receiptNumber={successReceiptNumber}
          onClose={() => setSuccessReceiptNumber(null)}
        />
      )}
    </div>
  );
}
